'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _prep2.default)({
    name: 'doIf',
    all: function all(predicate, ifTrue) {
        var ifFalse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (ii) {
            return ii;
        };
        return function (value) {
            return (predicate(value) ? ifTrue : ifFalse)(value);
        };
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/doIf.js
// module id = 388
// module chunks = 35783957827783